import Wizard from 'scoreboard/components/wizard'
import _ from 'lodash'
import DateFilterStep1 from './date-filter-step1'
import DateFilterStep2 from './date-filter-step2'
import DatasetsDateInPeriodFilterStep2 from 'scoreboard/datasets/filters/datasets-date-in-period-filter-step2'
import twoSteps from 'scoreboard/datasets/filters/two-steps'

const simpleValuePath = [DateFilterStep1]
const periodCalendarPath = [DateFilterStep1, DatasetsDateInPeriodFilterStep2]
const specificDatePath = [DateFilterStep1, DateFilterStep2]
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

function viewsByOperator(operator) {
	if (twoSteps(DATE, operator)) {
		if (operator == 'in-period') {
			return periodCalendarPath
		} else {
			return specificDatePath
		}
	} else {
		return simpleValuePath
	}
}

const DateFilterWizard = Wizard.extend({

	/**
	 * Wizard used for report date filters
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 */
	initialize: function(options) {
		this.options = options || {}
		Wizard.prototype.initialize.call(this, _.defaults({}, options, {
			views: simpleValuePath
		}))
	},

	_updateViews: function(operator) {
		this.setViews(viewsByOperator(operator))
		this.renderFooter()
	},

	_view: function(options) {
		let view = Wizard.prototype._view.call(this, options)
		this.currentView = view

		//step is 1 based
		if (this.views[this.step-1] === DateFilterStep1) {
			this.listenTo(view, 'change:operator', this._updateViews.bind(this))
		} else {
			this._updateViews()
		}

		this.listenTo(view, 'done', (data) => {
			this.trigger('done', data)
		})

		this.listenTo(view, 'next', (data) => {
			if (this.views.length == this.step) {
				view.trigger('done', data)
			} else {
				this.next(_.defaults({data: data}, this.options))
			}
		})

		return view
	}

})

_.extend(DateFilterWizard, {
	viewsByOperator
})

export default DateFilterWizard
export { viewsByOperator }
DateFilterWizard.__filename__ = 'reports/common/filter/date-filter-wizard.js'
